export function sortAlphabetically(elements?: Array<any> | null, property = 'name') {
  if (!elements) return [];

  return [...elements].sort((a, b) => {
    const propsA = a?.[property] || '';
    const propsB = b?.[property] || '';
    return propsA.localeCompare(propsB);
  });
}
